const ProblemComponent = () => {
  return (
    <section className="py-12 px-4 custom-bg-color-01">
      <div className="max-w-4xl mx-auto text-center">
        <h3 className="text-3xl font-bold mb-12 custom-color-03">
          Por que tantos cristãos permanecem presos, apesar do acesso à Palavra?
        </h3>

        <div className="rounded-2xl p-8 mb-8 custom-bg-color-03">
          <p className="leading-relaxed mb-4 custom-color-01">
            Muitos líderes e membros sinceros sentem-se frustrados ao perceber
            que, mesmo conhecendo a Bíblia, não conseguem promover mudança real
            em si ou nos outros.
          </p>
          <p className="leading-relaxed custom-color-01">
             Mesmo crendo nas promessas de vida plena e abundante das
            escrituras, muitos continuam presos por desconhecer o processo
            bíblico da mudança. Sim, a mudança é um processo. Sim, a Bíblia o
            apresenta com clareza. Sim, você pode entendê-lo e começar a mudar.
          </p>
        </div>
      </div>
    </section>
  );
};
export default ProblemComponent;
